import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchSimilarLocationListings } from './ListingPage.duck';
/**
 * Custom hook to fetch similar location listings based on the user's current location.
 * @param {String} currentUserOriginStr - The current user's location as a string.
 */
export const useSimilarLocationListingsRequest = (currentUserOriginStr, params = {}) => {
    const dispatch = useDispatch();

    const onSimilarLocationListingsFetching = location =>
        dispatch(fetchSimilarLocationListings(location, params));

    useEffect(() => {
        if (currentUserOriginStr) {
            onSimilarLocationListingsFetching(currentUserOriginStr);
        }
    }, [currentUserOriginStr]);
};
